import React from 'react';
import { useTranslation } from 'react-i18next';
import LogsTable from '../../components/LogsTable_v7';
import { customerLogTextV822 } from '../../components/customerLogV822';

const Log = () => {
  const { t } = useTranslation();

  return (
    <div className='dashboard-container management-container-v4'>
      <h2>{customerLogTextV822(t, 'ordinary')}</h2>
      <LogsTable customerScope='ordinary' />
    </div>
  );
};

export default Log;
